import React, { useEffect, useState } from "react";
import { Formik, FieldArray, Field } from "formik";
import Swal from "sweetalert2";
import * as notificationService from "../../services/notification.services";
import Breadcrums from "../../common/breadcrumbs";
import {
  blockInvalidChar,
  handleServerValidations,
} from "../../../../utils/commonfunction";
import { earningType, SWAL_SETTINGS } from "../../../../utils/Constants";
import Loader from "../../common/loader";
import { URL_REGEX, amountRegex, MOBILE_NUMBER_REGEX } from "../../../../utils/Constants";
import { useTranslation } from "react-i18next";
import { Toggle, Tooltip, Whisper } from "rsuite";
import "rsuite/dist/rsuite.min.css";

const PushNotifications = (props) => {
  const { t } = useTranslation();
  const [showdefault, setShowDefault] = useState({});
  // const [ setContactNumber] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(true);
  const [submitClicked, setSubmitClicked] = useState(false);
  const [previewimage, setPreviewImage] = useState("");


  return (
    <>
      {/* <Breadcrums data={breadcrumbs} /> */}
      {dataLoaded ? (
        <Formik

          validateOnChange={true}
          enableReinitialize
          initialValues={{
            title: "",
            description: "",
          }}
            validate={(values) => {
              let errors = {};

              if (!values.title || values.title.trim().length === 0) {
                errors.title = "Title is required";
              }

              if (!values.description || values.description.trim().length === 0) {
                errors.description = "Description is required";
              }

              return errors;
            }}
          onSubmit={(values, { setSubmitting, resetForm }) => {
              const title = values.title.trim();
              const description = values.description.trim();

              if (!title || !description) {
                setSubmitting(false);
                return;
              }

            setSubmitted(true);
            let formData = new FormData();
            formData.append("title", title);
            formData.append("description", description);
            
            notificationService
              .SendPushNotification(formData)
              .then((response) => {
                if (response.success) {
                  Swal.fire({
                    icon: "success",
                    text: response.message,
                    ...SWAL_SETTINGS,
                  });
                  setTimeout(() => {
                    setSubmitted(false);
                  }, 2000);
                } else {
                  Swal.fire({
                    icon: "error",
                    text: handleServerValidations(response),
                    ...SWAL_SETTINGS,
                  });
                  setSubmitted(false);
                }
              })
              .catch((error) => {
                console.log("error ====> ", error);
              });
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isSubmitting,
            setFieldTouched,
          }) => (
            <form onSubmit={handleSubmit}>
              {console.log("values", values)}
              {console.log("error", errors)}
              <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                  <div className="card custom-card">
                    <div className="card-body">
                      
                      <div className="row row-sm">
                        
                        <div className="col-md-6 text-center form-group">
                          <label
                            htmlFor="title"
                            className="text-left d-flex"
                          >
                            Title:<span className="requirestar">*</span>
                          </label>
                          <input
                            name="title"
                            type="text"
                            id="title"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.title}
                            className="form-control"
                            placeholder={ 'Enter Title'}
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.title &&
                              touched.title &&
                              errors.title}
                          </span>
                        </div>

                        <div className="col-md-6">
                        </div>      

                        <div className="col-md-6 text-center form-group">
                          <label
                            htmlFor="description"
                            className="text-left d-flex"
                          >
                            Description:<span className="requirestar">*</span>
                          </label>
                          <textarea
                            name="description"
                            type="text"
                            id="description"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.description}
                            className="form-control"
                            placeholder={ 'Enter Description'}
                          ></textarea>
                          <span className="text-danger d-flex text-left">
                            {errors.description &&
                              touched.description &&
                              errors.description}
                          </span>
                        </div>
                        

                        <div className="">
                          <button
                            className="btn btn-main-primary signbtn mr-2"
                            type="submit"
                            disabled={submitted ? true : null}
                            onClick={() => {
                              setSubmitClicked(true);
                            }}
                          >
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_submit")}
                          </button>
                        </div>
                        {/* ) : null} */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default PushNotifications;


